import { useApi } from 'services';

export const useGetCommercialPlansByIdOperationSync = (idOperation) => useApi(
    `/v2/operation/${idOperation}/commercial-plans`,
    'GET',
    {},
    {},
    true
);